
// Components/ChatContacts/components/FilterToggle.jsx
import React from "react";
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';

const FilterToggle = ({ filterType, handleFilterChange, unreadCount }) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 1,
            mb: 1
        }}>
            <ToggleButtonGroup
                value={filterType}
                exclusive
                onChange={handleFilterChange}
                aria-label="filtro de mensajes"
                size="small"
                sx={{
                    background: '#1f2c33',
                    borderRadius: '4px',
                    '& .MuiToggleButton-root': {
                        color: '#fff',
                        borderColor: '#2a3942',
                        textTransform: 'none',
                        px: 2,
                        '&.Mui-selected': {
                            backgroundColor: '#2a3942',
                            color: '#76c7c0',
                            '&:hover': {
                                backgroundColor: '#2a3942',
                            }
                        },
                        '&:hover': {
                            backgroundColor: 'rgba(42, 57, 66, 0.8)',
                        }
                    }
                }}
            >
                <ToggleButton value="all">
                    Todos
                </ToggleButton>
                <ToggleButton value="unread">
                    No leídos {unreadCount > 0 && `(${unreadCount})`}
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default FilterToggle;